import script from "./RagDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./RagDashboard.vue?vue&type=script&setup=true&lang=js"

import "./RagDashboard.vue?vue&type=style&index=0&id=676827c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676827c9"]])

export default __exports__